<template>
  <div class="district-table rounded-lg overflow-hidden border border-gray-100">
    <JdsDataTable
      :headers="tableHeader"
      :items="items"
      :loading="loading"
      :pagination="pagination"
      empty-text="Data tidak tersedia"
      @next-page="onPaginationChange('next-page', $event)"
      @previous-page="onPaginationChange('previous-page', $event)"
      @per-page-change="onPaginationChange('per-page-change', $event)"
      @page-change="onPaginationChange('page-change', $event)"
    >
      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.name="{item}">
        <p
          class="line-clamp-2"
          :title="item.name"
        >
          {{ item.name }}
        </p>
      </template>

      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.logo="{item}">
        <div class="w-[52px] h-[52px] rounded-md overflow-hidden">
          <img
            :src="item.logo"
            :alt="item.name"
            class="w-full h-full object-contain"
          >
        </div>
      </template>

      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.chief="{item}">
        <p
          class="line-clamp-2 max-w-[190px]"
          :title="item.chief"
        >
          {{ item.chief }}
        </p>
      </template>

      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.address="{item}">
        <p
          class="line-clamp-2"
          :title="item.address"
        >
          {{ item.address }}
        </p>
      </template>

      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.link="{item}">
        <a
          v-if="item.link"
          :href="item.link"
          class="font-lato text-sm underline line-clamp-2 break-all max-w-[190px]"
          rel="noopener noreferrer"
          target="_blank"
        >
          {{ item.link }}
        </a>
        <span v-else>-</span>
      </template>

      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.action="{item}">
        <DistrictTableAction
          :item="item"
          @open-preview="$emit('open-preview', $event)"
          @delete="$emit('delete', $event)"
        />
      </template>
    </JdsDataTable>
  </div>
</template>

<script>
import { DISTRICT_TABLE_HEADER } from '@/common/constants';
import DistrictTableAction from '@/components/Profiles/District/DistrictTableAction.vue';

export default {
  name: 'DistrictTable',
  components: {
    DistrictTableAction,
  },
  props: {
    items: {
      type: Array,
      require: false,
      default: () => [],
    },
    loading: {
      type: Boolean,
      require: false,
      default: false,
    },
    meta: {
      type: Object,
      require: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableHeader: DISTRICT_TABLE_HEADER,
      pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalRows: 0,
        itemsPerPageOptions: [10, 20, 30, 40, 50],
      },
    };
  },
  watch: {
    meta: {
      handler() {
        this.pagination = {
          ...this.pagination,
          currentPage: this.meta?.current_page || 1,
          itemsPerPage: this.meta?.per_page || 10,
          totalRows: this.meta?.total_count || 0,
        };
      },
      immediate: true,
    },
  },
  methods: {
    onPaginationChange(action, value) {
      const paginationObj = { ...this.pagination };

      switch (action) {
        case 'next-page':
        case 'previous-page':
        case 'page-change':
          paginationObj.currentPage = value;
          break;

        case 'per-page-change':
          paginationObj.itemsPerPage = value;
          break;

        default:
          break;
      }

      this.pagination = { ...paginationObj };

      /**
       *  NOTE:
       *  `jds-pagination` emits `per-page-change` and `page-change` events
       *  whenever user changes per page value.
       *
       *  To avoid double fetch, we immediately stop this function on
       *  `per-page-change` event and let `page-change` event to
       *  fetch data from API
       */

      if (action === 'per-page-change') {
        return;
      }

      this.$emit('update:pagination', {
        page: this.pagination.currentPage,
        per_page: this.pagination.itemsPerPage,
      });
    },

    onSortChange(sort) {
      this.$emit('change:sort', {
        sort_by: Object.keys(sort)[0],
        sort_order: Object.values(sort)[0].toUpperCase(),
      });
    },
  },
};
</script>

<style>
/**
 * Override default jds-data-table style
 */
.district-table .jds-data-table {
  table-layout: fixed !important;
}

.district-table .jds-data-table thead tr th:nth-child(4) {
  width: 250px !important;
}

.district-table .jds-data-table thead tr th:nth-child(2) {
  width: 90px !important;
}

.district-table .jds-data-table thead tr th:nth-child(1),
.district-table .jds-data-table thead tr th:nth-child(3),
.district-table .jds-data-table thead tr th:nth-child(5) {
  width: 200px !important;
}

.district-table .jds-data-table thead tr th:nth-child(6) {
  width: 120px !important;
}
</style>
